import $ from 'jquery';
const ignoreNode = function (node) {
  return /META|STYLE|LINK|:/.test(node.tagName) || node.nodeType !== undefined && node.nodeType === node.ELEMENT_NODE && /ListGhost|EmptyTextRun/.test(node.className);
};
const isEndOfOrderedList = function (node) {
  let parentNode = node.parentNode;
  let nextElement = parentNode.nextElementSibling;
  let currentStartValue = parentNode.getAttribute('start');
  return !nextElement || nextElement && nextElement.tagName !== 'OL' || nextElement && nextElement.tagName === 'OL' && /^\d+$/.test(currentStartValue) && nextElement.getAttribute('start') !== `${parseInt(currentStartValue, 10) + 1}`;
};
const nodeToHtml = function (node, allowedChildNodeNames) {
  let html = '';
  if (node.nodeType === undefined) {
    //node list
    let nodes = node;
    for (let i = 0; i < nodes.length; i++) {
      node = nodes[i];
      if (ignoreNode(node)) {
        //eslint-disable-next-line no-continue
        continue;
      }
      if (allowedChildNodeNames === undefined || node.nodeType === Node.TEXT_NODE || $.inArray(node.nodeName, allowedChildNodeNames) >= 0) {
        html += nodeToHtml(node);
      } else {
        html += node.textContent;
      }
    }
    return html;
  } else {
    if (ignoreNode(node)) {
      return html;
    }
    let tagName = node.tagName;
    let className = node.className;
    if (tagName === 'OL' && node.getAttribute('start') > 1) {
      return nodeToHtml(node.childNodes, ['LI']);
    } else if (tagName === 'OL') {
      return `<ol class='pl_editable_block'>${nodeToHtml(node.childNodes, ['LI'])}`;
    } else if (tagName === 'UL') {
      return `<ul class='pl_editable_block'>${nodeToHtml(node.childNodes, ['LI'])}</ul>`;
    } else if (tagName === 'LI') {
      let html = nodeToHtml(node.childNodes, ['SPAN', 'P', 'DIV']);
      //Check if we are at the end of an ordered list
      if (node.parentNode.tagName === 'OL' && isEndOfOrderedList(node)) {
        return `<li>${html}</li></ol>`;
      }
      return `<li>${html}</li>`;
    } else if (tagName === 'P' && !/^(TH|TD)$/.test(node.parentNode.tagName)) {
      return `<p class='pl_editable_block'>${nodeToHtml(node.childNodes, ['A', 'SPAN'])}</p>`;
    } else if (/^(TABLE|TBODY)$/.test(node.tagName)) {
      return nodeToHtml(node.childNodes, ['TR', 'TBODY']);
    } else if (tagName === 'TR') {
      return `<p class='pl_editable_block'>${nodeToHtml(node.childNodes, ['TD', 'TH'])}</p>`;
    } else if (/^(TH|TD)$/.test(tagName)) {
      return `${nodeToHtml(node.childNodes, ['A', 'P'])} `;
    } else if (/^TextRun/.test(className) && /italic/.test(node.getAttribute('style'))) {
      return `<i>${nodeToHtml(node.childNodes, ['A', 'SPAN'])}</i>`;
    } else if (/^TextRun/.test(className) && /bold/.test(node.getAttribute('style'))) {
      return `<b>${nodeToHtml(node.childNodes, ['A', 'SPAN'])}</b>`;
    } else if (tagName === 'A') {
      return `<a href=\"${node.href}\">${nodeToHtml(node.childNodes, ['SPAN'])}</a>`;
    } else if (tagName === 'DIV') {
      return nodeToHtml(node.childNodes, ['DIV', 'SPAN', 'TABLE', 'OL', 'UL', 'P']);
    } else if (tagName === 'SPAN') {
      return nodeToHtml(node.childNodes, ['SPAN', 'IMG']);
    } else if (tagName === 'IMG') {
      return `<img src=\"${node.src}\" />`;
    } else {
      return node.textContent;
    }
  }
};
let cleanDocument = function (html) {
  // eslint-disable-next-line jquery-unsafe/no-html
  let $content = $('<div>').html(html);
  let nodes = $content[0].childNodes;
  let cleanedHtml = '';
  for (let i = 0, length = nodes.length; i < length; i++) {
    let node = nodes[i];
    cleanedHtml += nodeToHtml(node);
  }
  return cleanedHtml;
};
export default function (html) {
  return /TableWordWrap|TextRun|OutlineElement|NumberListStyle|BulletListStyle/gi.test(html) ? cleanDocument(html) : html;
}